"use strict";
// packages/contracts/src/vendas-fechamento.ts — Fase 12, Plano 13 (FECH-01, FECH-02, FECH-05, FECH-06).
// Contrato compartilhado API/web do fechamento do PV: lotes disponiveis, simulacao, fechamento (Retorno retido)
// e revisao/aprovacao do rascunho fiscal. Somente `pv:fechar` habilita as escritas; a leitura do rascunho e `pv:ler`.
// O rascunho APROVADO e imutavel (snapshot enviado a Omie) e nenhum campo fiscal e "padrao": CFOP/NCM/CST/cBenef/ICMS
// vem do modelo fiscal versionado (12-03) por linha, nunca de um default deste contrato.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=vendas-fechamento.js.map